import { Grid, Skeleton } from '@mui/material';
import { CardSection, CardSubSection } from '@side/pantry';
import type { ListingSummaryResult } from '@/components/ListingSummaryCard/useListingSummary';
import { ReadOnlyField } from '@/components/ReadOnlyField/ReadOnlyField';

type Props = {
  listing: ListingSummaryResult | undefined;
  loading: boolean;
};

export const MLSReadOnlyCard = ({ listing, loading }: Props) => {
  return (
    <CardSection cardTitle="Search property by MLS">
      <CardSubSection sx={{ py: 3 }}>
        <Grid container columnSpacing={2}>
          <Grid size={6}>
            <ReadOnlyField
              label="MLS Vendor"
              value={
                loading ? (
                  <Skeleton width="60%" />
                ) : (
                  (listing?.mlsVendorName ?? null)
                )
              }
            />
          </Grid>
          <Grid size={6}>
            <ReadOnlyField
              label="MLS Number"
              value={
                loading ? (
                  <Skeleton width="60%" />
                ) : (
                  (listing?.mlsNumber ?? null)
                )
              }
            />
          </Grid>
        </Grid>
      </CardSubSection>
    </CardSection>
  );
};
